import { camelCase, upperFirst } from 'lodash';
import { Button } from 'primereact/button';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PlatformOverviewDetailBody } from './PlatformOverviewDetailBody';
import PageHeader from '../../common/PageHeader';

export const PlatformOverviewDetails = (props) => {
    const navigate = useNavigate();

    const { platformName } = useParams()
    const setLoadingInProps = props.setLoading

    const goBack = () => {
        navigate(-1);
    }

    return (
        <div className='content-container'>
            <div style={{ maxWidth: "100%" }}>
                <PageHeader
                    title={upperFirst(camelCase(platformName))}
                    subtitle="Originator overview"
                    icon="pi-chart-pie"
                    actions={<Button id='go-back-simon' label="Back" icon="pi pi-arrow-left" className="p-button-text" type='button' onClick={goBack} />}
                />
                <PlatformOverviewDetailBody platformName={platformName} setLoading={setLoadingInProps} />
            </div>
        </div>
    );
}

export default PlatformOverviewDetails;
